<p-dialog [visible]="visible()" (visibleChange)="visible.set($event)" [modal]="true" appendTo="body"
  [draggable]="true" [resizable]="false" [closable]="!sending()" [dismissableMask]="!sending()"
  header="Send Certificate of Insurance" styleClass="menu-dialog"
  [style]="{ width: '480px' }" [breakpoints]="{ '520px': '94vw' }">

  @if (loadingChannels()) {
    <div class="sc-loading"><i class="pi pi-spin pi-spinner"></i> Checking available channels…</div>
  } @else if (channelsFailed()) {
    <div class="sc-note">
      <i class="pi pi-exclamation-triangle"></i>
      Couldn't check this member's channels. You can still send — the certificate goes out only on
      the channels enabled for their partner/client.
    </div>
  } @else if (info(); as inf) {
    @if (!inf.issued) {
      <div class="sc-note warn">
        <i class="pi pi-info-circle"></i>
        The certificate can be sent only after the payment succeeds and the policy is issued.
      </div>
    } @else if (noneEnabled()) {
      <div class="sc-note warn">
        <i class="pi pi-ban"></i>
        <span>
          No channel is enabled for this member's <strong>{{ inf.owner }}</strong>. Enable
          WhatsApp / SMS / Email in
          {{ inf.owner === 'client' ? 'Client SMS / Message-type Manage' : "the partner's messaging settings" }}
          first.
        </span>
      </div>
    } @else {
      @if (inf.policyNo) {
        <div class="sc-policy">Policy <span class="mono">{{ inf.policyNo }}</span></div>
      }

      <div class="sc-section-label">Documents</div>
      <div class="sc-channels">
        <label class="sc-channel">
          <p-checkbox [binary]="true" [ngModel]="docCoi()" (ngModelChange)="docCoi.set($event)" />
          <i class="sc-ch-icon pi pi-verified"></i>
          <span class="sc-ch-label">Certificate of Insurance</span>
        </label>
        <label class="sc-channel">
          <p-checkbox [binary]="true" [ngModel]="docReceipt()" (ngModelChange)="docReceipt.set($event)" />
          <i class="sc-ch-icon pi pi-receipt"></i>
          <span class="sc-ch-label">Payment receipt</span>
        </label>
      </div>

      <div class="sc-section-label">Send on</div>
      <div class="sc-channels">
        @for (c of visibleChannels(); track c.key) {
          <label class="sc-channel" [class.off]="!isDeliverable(c.key)">
            <p-checkbox [binary]="true" [ngModel]="selected().has(c.key)"
              (ngModelChange)="toggleChannel(c.key, $event)" [disabled]="!isDeliverable(c.key)" />
            <i class="sc-ch-icon" [class]="c.icon"></i>
            <span class="sc-ch-label">{{ c.label }} <small>{{ c.desc }}</small></span>
            @if (!isDeliverable(c.key)) {
              <small class="sc-ch-hint">no {{ c.needs }} on file</small>
            }
          </label>
        }
      </div>
      <p class="sc-caption">
        Sent only on the channels enabled for this member's {{ inf.owner }} — your choice can narrow
        that, not add to it.
      </p>

      <!-- Send to (optional overrides) -->
      <div class="sc-overrides">
        <div class="sc-override">
          <label>Email</label>
          @if (editEmail()) {
            <input pInputText type="email" [ngModel]="emailOverride()"
              (ngModelChange)="emailOverride.set($event)" placeholder="name@example.com" />
          } @else {
            <span class="sc-onfile" [class.none]="!inf.hasEmail">
              <i [class]="inf.hasEmail ? 'pi pi-check-circle' : 'pi pi-minus-circle'"></i>
              {{ inf.hasEmail ? "Member's email on file" : 'No email on file' }}
            </span>
            <p-button label="Edit" size="small" [text]="true" (onClick)="editEmail.set(true)" />
          }
        </div>
        <div class="sc-override">
          <label>Mobile</label>
          @if (editMobile()) {
            <input pInputText type="tel" [ngModel]="mobileOverride()"
              (ngModelChange)="mobileOverride.set($event)" placeholder="9876543210" />
          } @else {
            <span class="sc-onfile" [class.none]="!inf.hasMobile">
              <i [class]="inf.hasMobile ? 'pi pi-check-circle' : 'pi pi-minus-circle'"></i>
              {{ inf.hasMobile ? "Member's mobile on file" : 'No mobile on file' }}
            </span>
            <p-button label="Edit" size="small" [text]="true" (onClick)="editMobile.set(true)" />
          }
        </div>
      </div>

      <p class="sc-queued-note">
        <i class="pi pi-clock"></i>
        Messages are <strong>queued for delivery</strong> — sending happens in the background.
      </p>
    }
  }

  <div class="modal-actions">
    <p-button label="Cancel" [outlined]="true" (onClick)="close()" [disabled]="sending()" />
    <p-button [label]="sending() ? 'Queueing…' : 'Send'" icon="pi pi-send" (onClick)="send()"
      [disabled]="!canSend()" [loading]="sending()" />
  </div>
</p-dialog>
